import { Component, Input } from '@angular/core';
import { ProductViewHelperService } from 'modules/shared-postlogin/services/product-view-helper.service';

@Component({
    selector: 'update-banner',
    templateUrl: './update-banner.template.html',
    styleUrls: ['./update-banner.style.scss'],
    standalone: false
})
export class UpdateBanner {
  @Input() bannerMsg: any;
  
    constructor(
    private productViewHelperService: ProductViewHelperService ) {}
    // Close banner
    closeBanner() {
      this.productViewHelperService.showContentAccessItemsUpdatedMsg.next(false);
    }
}
